import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/helpharma.png'


const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  })
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "login-box-msg" }, " Usa tus credenciales para iniciar sesión ", -1)
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_11 = { class: "mb-1 mt-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ¿Olvidaste tu contraseña? ")

export function render(_ctx, _cache) {
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_button = _resolveComponent("app-button")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.loginByAuth && _ctx.loginByAuth(...args)), ["prevent"]))
        }, [
          _createVNode(_component_app_input, {
            icon: "envelope",
            class: "mb-3",
            type: "email",
            placeholder: "Correo electrónico",
            autocomplete: "off",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: _ctx.showPassword ? 'text':'password',
              class: _normalizeClass({'form-control': true }),
              id: "confirmPassword",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.password) = $event)),
              placeholder: "Contraseña",
              autocomplete: "off"
            }, null, 8, _hoisted_7), [
              [_vModelDynamic, _ctx.password]
            ]),
            _createElementVNode("span", {
              class: "input-group-text rounded-left-0 rounded-right",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.showPassword = !_ctx.showPassword))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([_ctx.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_app_button, {
                class: "btn-primary",
                type: "submit",
                block: "true",
                loading: _ctx.isAuthLoading,
                disabled: _ctx.isFacebookLoading || _ctx.isGoogleLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ])
          ])
        ], 32),
        _createElementVNode("p", _hoisted_11, [
          _createVNode(_component_router_link, { to: "/forgot-password" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}